import React from "react";
import {
    Box,
    Container,
    Tab,
    Tabs,
    AppBar,
    Card,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import Page from '../../components/Page';
import { connect, useSelector } from 'react-redux';
import theme from "../../theme";
import Toolbar from './EngineerToolbar';
import Graph from './EngineeringGraph/Graph'
import { maxHeight } from "@mui/system";
import { styled } from '@mui/system';


const MyPage = styled(Page)({
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
})

const EngineeringView = (props) => {
    const [data, setData] = React.useState([]);

    return (
        <MyPage title="Engineering Management" >
            <Container maxWidth={false}>
                <Toolbar data={data} setData={setData} hideLimit={false} />
                <Box height={'100%'} width={'100%'}>
                    <Graph />
                </Box>                
            </Container>
        </MyPage>
    );
}
export default EngineeringView;
